
/* injects from baggage-loader */

'use strict';

export default function (app) {
  app
    .factory('Dialog', DialogFactory);

  function DialogFactory($uibModal) {
    'ngInject';

    let self = {};

    self.showFail = function(title, text, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogAlert',
        controllerAs: "$ctrl",
        resolve:{
          title: () => title,
          text: () => text
        },
        windowClass: 'alert-modal'
      }).result.then(callback, cancelFn);
    };

    self.showAlert = function(title, text, img, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogAlert',
        controllerAs: "$ctrl",
        resolve:{
          title: () => title,
          text: () => text,
          img: () => img,

        },
        windowClass: 'alert-modal'
      }).result.then(callback, cancelFn);
    };

    self.showPuzzle = function(title, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogPuzzle',
        controllerAs: "$ctrl",
        resolve:{
          title: () => title,
        },
        windowClass: 'alert-modal'
      }).result.then(callback, cancelFn);
    };

    self.showMenu = function(callback, cancelFn){
      $uibModal.open({        
        component: 'dialogMenu',
        controllerAs: "$ctrl",
      }).result.then(callback, cancelFn);
    };

    self.showFeedback = function (title, text, starCount, callback, cancelFn) {
      $uibModal.open({        
        component: 'dialogFeedback',
        controllerAs: "$ctrl",
        backdrop: 'static',
        resolve: {
          title: () =>  title,
          text: () =>  text,
          starCount: () => starCount
        }
      }).result.then(callback, cancelFn);
    };

    self.showIntroModal = function(callback, cancelFn){
      $uibModal.open({
        animation: false,
        component: 'dialogIntro',
        controllerAs: "$ctrl",
        backdrop: false,
        keyboard: false,
        windowClass: 'interventional-modal',
      }).result.then(callback, cancelFn);
    };

    self.showIntroBookModal = function(callback, cancelFn){
      $uibModal.open({
        animation: false,
        component: 'dialogIntroBook',
        controllerAs: "$ctrl",
        backdrop: false,
        keyboard: false,
        windowClass: 'interventional-modal',
      }).result.then(callback, cancelFn);
    };

    self.showStagesModal = function(callback, cancelFn){
      $uibModal.open({        
        component: 'dialogStages',
        controllerAs: "$ctrl",
        backdrop: false,
        keyboard: false,
        windowClass: 'interventional-modal',
      }).result.then(callback, cancelFn);
    };

    self.showInterventionalModal = function(title, ballons, callback, cancelFn){
      $uibModal.open({
        animation: false,
        component: 'dialogInterventional',
        controllerAs: "$ctrl",
        backdrop: false,
        keyboard: false,
        windowClass: 'interventional-modal',
        resolve: {
          title: () =>  title,
          ballons: () => ballons
        }
      }).result.then(callback, cancelFn);
    };

    self.showInterventionalTrophiesModal = function(totalParts, callback, cancelFn){
      $uibModal.open({
        animation: false,
        ariaDescribedBy: 'Parabéns você conseguiu ganhar alguns troféis',
        component: 'dialogTrophies',
        controllerAs: "$ctrl",
        backdrop: false,
        keyboard: false,
        windowClass: 'interventional-modal',
        resolve: {
          totalParts: () => totalParts
        }
      }).result.then(callback, cancelFn);
    };

    self.showInterventionalFormsModal = function(callback, cancelFn){
      $uibModal.open({
        animation: false,
        ariaDescribedBy: 'Parabéns você ganhou três pacotes de figurinhas',
        component: 'dialogForms',
        controllerAs: "$ctrl",
        backdrop: false,
        keyboard: false,
        windowClass: 'interventional-modal',
      }).result.then(callback, cancelFn);
    };

    return self;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/dialogs.factory.js